import { configureStore } from '@reduxjs/toolkit';
import { authApi } from './api/auth';
import { workspaceApi } from './api/workspaces';
import { projectApi } from './api/projects';
import { taskApi } from './api/tasks';
import { userApi } from './api/users';
import { templateApi } from './api/templates';
import authReducer from './slices/authSlice';
import workspaceReducer from './slices/workspaceSlice';
import filterReducer from './slices/filterSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    workspace: workspaceReducer,
    filter: filterReducer,
    [authApi.reducerPath]: authApi.reducer,
    [workspaceApi.reducerPath]: workspaceApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    [taskApi.reducerPath]: taskApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [templateApi.reducerPath]: templateApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      workspaceApi.middleware,
      projectApi.middleware,
      taskApi.middleware,
      userApi.middleware,
      templateApi.middleware
    ),
});

export { store };
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

